import { render } from "./PostCategory.vue?vue&type=template&id=e013237e&scoped=true"
import script from "./PostCategory.vue?vue&type=script&lang=js"
export * from "./PostCategory.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e013237e"]])

export default __exports__